import { useAtom } from "jotai";
import type { FunctionComponent } from "react";

import { myNewsAtom } from "scmp-app/lib/mynews";

import IconClose from "./icon-share-close.svg";
import {
  Backdrop,
  Card,
  CloseButton,
  Container,
  Description,
  StyledBaseLink,
  Title,
} from "./styles";

export const MynewsCard: FunctionComponent = () => {
  const [mynews, setMynews] = useAtom(myNewsAtom);

  const onClose = () => {
    setMynews({ isShowIndicatorCard: false });
  };

  if (!mynews.isShowIndicatorCard) {
    return null;
  }

  return (
    <Container>
      <Backdrop onClick={onClose} />
      <Card>
        <CloseButton onClick={onClose}>
          <IconClose />
        </CloseButton>
        <Title>
          About <i>my</i>
          <span>NEWS</span>
        </Title>
        <Description>
          Curating news that matters to you with our <span>Daily 5 must-read articles</span> plus a
          comprehensive list of stories from your favourite topics.
        </Description>
        <StyledBaseLink pathname="/about-mynews">READ MORE</StyledBaseLink>
      </Card>
    </Container>
  );
};

MynewsCard.displayName = "MynewsCard";
